import { FC, useMemo } from "react";
import styled, { css } from "styled-components";

type Props = {
  opened: boolean;
  onToggle: () => void;
};
const Hamburger: FC<Props> = ({ onToggle, opened }) => {
  const activeClass = useMemo(() => opened ? "active" : "", [opened])
  return (
    <Root onClick={onToggle}>
      <FirstLine className={activeClass} />
      <SecondLine className={activeClass} />
      <ThirdLine className={activeClass} />
    </Root>
  )
}
export default Hamburger;

const Root = styled.div`
  position: relative;
  cursor: pointer;
  width: 36px;
  height: 36px;
  @media screen and (min-width: 961px) {
    display: none;
  }
`;
const lineCss = css`
  display: inline-block;
  transition: all .4s;
  position: absolute;
  left: 3px;
  // right: 3px
  height: 3px;
  border-radius: 2px;
  background: #fff;
  width: 30px;
`;

const FirstLine = styled.span`
  ${lineCss};
  top: 6px;

  &.active {
    transform: translateY(10.6px) rotate(-45deg);
  }
`;

const SecondLine = styled.span`
  ${lineCss};
  top: 16.5px;

  &.active {
    opacity: 0;
  }
`;

const ThirdLine = styled.span`
  ${lineCss};
  top: 27px;

  &.active {
    transform: translateY(-10.6px) rotate(45deg);
  }
`;
